import Api from "../../utils/axios";

export const PromotionalMangementApi = {
  promosales: {
    getAllPromotionalSales: (payload, search = "") =>
      Api.post(`admin/get-all-sales?search=${search}`, payload),
    updatePromosales: (id, payload) =>
      Api.patch(`admin/sale-approval/${id}`, payload),
  },
};
